import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import "animate.css";
import { Fragment, useEffect } from "react";
import PrivateRoute from "./PrivateRoute";
import { getAuth } from "./redux/features/authSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { sideBarLinks } from "./utils/constants";
import NotFound from "./pages/NotFound";
import DashboardLanding from "./pages/Dashboard/DashboardLanding";
import AddMine from "./pages/Mines/AddMine";
import AddLogistics from "./pages/LogisticsProviders/AddLogistics";
import AddRefineries from "./pages/Refineries/AddRefineries";
import AddVaults from "./pages/Vaults/AddVaults";
import DocumentationChecklist from "./components/Forms/DocumentationChecklist";
import BeneficialOwnership from "./components/Forms/BeneficialOwnership";
import RiskAssesment from "./components/Forms/RiskAssesment";
import Acknowledgment from "./components/Forms/Acknowledgment";
import MinesUserListing from "./pages/MinesUserListing";
import LogisticUserListing from "./pages/LogisticUserListing";
import RifineryUserListing from "./pages/RifineryUserListing";
import VaultUserListing from "./pages/VaultUserListing";
import KYC from "./components/Forms/KYC";
import KycListing from "./pages/KycListing";
import KycUserListing from "./pages/KycUserListing";
import AdminKyc from "./components/Forms/AdminKyc";
import RefineryRequest from "./pages/RefineryRequest";
import RefineryConsignmentDetails from "./pages/RefineryRequest/RefineryConsignmentDetails";
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  console.log(pathname, "pathname");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleLogOut = async () => {
      try {
        Cookies.remove("accessToken");
        Cookies.remove("testnetaccessToken");
        navigate("/");
        toast.success(
          "Your session has expired. Please log in again to continue"
        );
      } catch (err) {
        toast.error(err.message);
      }
    };

    const setAuth = async () => {
      try {
        const result = dispatch(getAuth());
        if (result?.payload?.response?.data?.message === "Unauthorized") {
          await handleLogOut();
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (Cookies.get(`${process.env.REACT_APP_NETWORK}accessToken`) === "true") {
      setAuth();
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const cookeiData = Cookies.get(
      `${process.env.REACT_APP_NETWORK}accessToken`
    );
    if (!cookeiData) {
      navigate("/");
    }
  }, [navigate]);
  return (
    <>
      <ToastContainer autoClose={2000} />
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path="dashboard" element={<DashboardLanding />}></Route>
          <Route path="/mine-user-list" element={<MinesUserListing />}></Route>
          <Route
            path="/logi-user-list"
            element={<LogisticUserListing />}
          ></Route>
          <Route
            path="/refi-user-list"
            element={<RifineryUserListing />}
          ></Route>
          <Route path="/vault-user-list" element={<VaultUserListing />}></Route>

          <Route path="add-mine" element={<AddMine />}></Route>
          <Route path="add-mine/:id" element={<AddMine />} />

          <Route path="add-logistics" element={<AddLogistics />}></Route>
          <Route path="add-logistics/:id" element={<AddLogistics />}></Route>

          <Route path="/add-refineries" element={<AddRefineries />}></Route>
          <Route path="/add-refineries/:id" element={<AddRefineries />}></Route>
          <Route path="add-vaults" element={<AddVaults />}></Route>
          <Route path="add-vaults/:id" element={<AddVaults />}></Route>
          <Route path="risk-assesment" element={<RiskAssesment />}></Route>
          <Route path="risk-assesment/:id" element={<RiskAssesment />}></Route>
          <Route path="refinery-request" element={<RefineryRequest />}></Route>
          <Route
            path="refinery-consignment-request/:id"
            element={<RefineryConsignmentDetails />}
          ></Route>

          <Route path="kyc" element={<KYC />}></Route>
          <Route path="kyc/:id" element={<KYC />}></Route>
          <Route path="admin-kyc" element={<AdminKyc />}></Route>
          <Route path="admin-kyc/:id" element={<AdminKyc />}></Route>
          <Route path="acknowledgment" element={<Acknowledgment />}></Route>
          <Route path="acknowledgment/:id" element={<Acknowledgment />}></Route>

          <Route path="acknowledgment/:id" element={<Acknowledgment />}></Route>
          <Route
            path="documentation-checklist"
            element={<DocumentationChecklist />}
          ></Route>
          <Route
            path="documentation-checklist/:id"
            element={<DocumentationChecklist />}
          ></Route>
          <Route
            path="beneficial-ownership"
            element={<BeneficialOwnership />}
          ></Route>
          <Route
            path="beneficial-ownership/:id"
            element={<BeneficialOwnership />}
          ></Route>

          <Route path="kyc-listing" element={<KycListing />}></Route>
          <Route path="kyc-user-listing" element={<KycUserListing />}></Route>

          {/* {sideBarLinks.map(
            (item, index) =>
              item.title !== "Dashboard" && (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                ></Route>
              )
          )} */}
          {sideBarLinks.map((item, index) => {
            if (item.component === null && item.child) {
              return item.child.map((childItem, childIndex) => (
                <Route
                  key={`${index}-${childIndex}`}
                  path={childItem.path}
                  element={<Fragment>{childItem.component}</Fragment>}
                />
              ));
            } else if (item.title !== "Dashboard") {
              // Render routes for other items except "Dashboard"
              return (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                />
              );
            }
            return null;
          })}

          <Route path="*" element={<NotFound />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
